module.exports = __webpack_public_path__ + "static/media/avantgarde_rapid.a27ca535.pdf";